module.exports = new __parcel__URL__("close.1badc6c3.svg").toString();